import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectProductGroupsByCompanyIdSiteId, selectProductGroupsByCompanyId } from './store/reducers';
import { UUID } from 'angular2-uuid';

import * as ProductGroupActions from './store/actions/product-groups.actions';
// import * as MediaLibraryActions from '../media-libraries/store/actions/media-libraries.actions';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { map } from 'rxjs/operators';
import { ProductGroup } from '../models/product-group.model';

@Injectable({
  providedIn: 'root'
})
export class ProductGroupsService {
  messages$: any;
  public productGroupChangeRef = new BehaviorSubject<any>([]);

  constructor(
    private store: Store<any>,
    protected db: AngularFirestore,
  ) {

    const preProductGroups = [
      '1st message',
      '2nd message',
      '3rd message',
      '4th message',
      '5th message'
    ];

    // this.messages$ = this.productGroup.select(selectAllProductGroups);

    // for (let i = 0; i < preProductGroups.length; i++) {
    //   this.addProductGroup(preProductGroups[i]);
    // }

    // this.getProductGroups();
  }

  public changeProductGroup(product: any) {

    this.productGroupChangeRef.next(product);
  }


  addProductGroup(value: any) {
    const productGroup: ProductGroup = {
      // id: this.generateUUID(),
      companyId: value.companyId,
      siteId: value.siteId,
      heading: value.heading,
      detail: value.detail,
      file: value.file,
      fileType: value.fileType,
      image: value.image,
      sortOrder: value.sortOrder,
      atCategories: value.atCategories,
      tags: value.tags || {},
      width: value.width || 60,
      height: value.height || 60,
      productGroup: 100,
      atSites: value.atSites,
      dayTimes: value.dayTimes,
      weekDays: value.weekDays,
      af: value.af,
      da: value.da,
      do: value.do,
      ni: value.ni

    };

    this.store.dispatch(new ProductGroupActions.AddProductGroup(productGroup));

  }

  addProductGroupFirebase$(productGroup: ProductGroup) {
    return this.db.collection('ts__productgroups').add(productGroup);
  }

  setStockFirebase$(productgroups: ProductGroup) {
    return this.db.collection('ts__productgroups').doc(productgroups.id).set({...productgroups});
  }

  updateProductGroupFirebase$(productGroup: any) {
    console.log('updateProductGroupFirebase$: e', productGroup);

    const productsRef: AngularFirestoreDocument<any> = this.db.collection('ts__productgroups').doc(productGroup.id);

    const ProductGroupData: any = Object.assign({}, productGroup);

    return of(productsRef.set(ProductGroupData, { merge: true }));
  }

  deleteProductGroup(id: string) {
    this.store.dispatch(new ProductGroupActions.DeleteProductGroup(id));
  }

  destroyProductGroup(id: string) {
    this.store.dispatch(new ProductGroupActions.DestroyProductGroup(id));
  }

  destroyProductGroupFirebase$(id: string) {
    return this.db.collection('ts__productgroups').doc(id).delete();
  }

  deleteProductGroupFirebase$(id: string) {
    return this.db.collection('ts__productgroups').doc(id).delete();
  }

  updateProductGroup(productGroup: any) {
    console.log('updateProductGroupupdateProductGroupupdateProductGroupupdateProductGroup: e', productGroup);
    this.store.dispatch(
      new ProductGroupActions.UpdateProductGroup(productGroup)
    );

  }

  getProductGroups() {
    this.store.dispatch(new ProductGroupActions.FetchProductGroups());
  }

  getProductGroupsByCompanyId(companyId: string) {
    this.store.dispatch(new ProductGroupActions.FetchProductGroupsByCompanyId(companyId));
  }

  getProductGroupsByCompanyIdSiteId(companyId: string, siteId: string) {
    this.store.dispatch(new ProductGroupActions.FetchProductGroupsByCompanyIdSiteId(companyId, siteId));
  }

  getProductGroupsByCompanyId$(id: string): Observable<any> {

    const categoriesCollection = this.db.collection<any>('ts__productgroups', ref => ref
      .where('companyId', '==', id)
    );


    return categoriesCollection.snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const theId = a.payload.doc.id;
            return { id: theId, ...data };
          });
        })
      );
  }

  getProductGroupsByCompanyIdSiteId$(companyId: string, siteId: string): Observable<any> {

    const categoriesCollection = this.db.collection<any>('ts__productgroups', ref => ref
      .where('companyId', '==', companyId)
      .where('siteId', '==', siteId)
    );

    return categoriesCollection.snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const theId = a.payload.doc.id;
            return { id: theId, ...data };
          });
        })
      );
  }

  findProductGroupsByCompanyId(id: string): Observable<ProductGroup[]> {

    return this.store.select(selectProductGroupsByCompanyId, { id });

  }

  findProductGroupsByCompanyIdSiteId(companyId: string, siteId: string): Observable<ProductGroup[]> {
    return this.store.select(selectProductGroupsByCompanyIdSiteId, { companyId, siteId });
  }

  generateUUID() {
    return UUID.UUID();
  }
}
